import { useExternalRoleQuery } from './useExternalRoleQuery';
import { useExternalRolesQuery } from './useExternalRolesQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface UpdateExternalRoleMutationParams {
  id: string;
  name?: string;
  description?: string;
  permissions?: string[];
}

export const useExternalRoleUpdateMutation = createMutationHook(
  'settings.customerPortal.updateRole',
  (params: UpdateExternalRoleMutationParams) => ({
    coreRoleUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          description: params.description,
          permissions: params.permissions,
        },
      },
      id: true,
      name: true,
      permissions: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
  {
    invalidateQueries: [useExternalRoleQuery, useExternalRolesQuery],
  },
);
